import { render } from "./TheLoader.vue?vue&type=template&id=4fa97f2d&scoped=true&ts=true"
import script from "./TheLoader.vue?vue&type=script&lang=ts"
export * from "./TheLoader.vue?vue&type=script&lang=ts"

import "./TheLoader.vue?vue&type=style&index=0&id=4fa97f2d&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src317777935/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa97f2d"]])

export default __exports__